import { render, staticRenderFns } from "./DocumentSigningView.vue?vue&type=template&id=036b6c28&scoped=true"
import script from "./DocumentSigningView.vue?vue&type=script&lang=js"
export * from "./DocumentSigningView.vue?vue&type=script&lang=js"
import style0 from "./DocumentSigningView.vue?vue&type=style&index=0&id=036b6c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b6c28",
  null
  
)

export default component.exports